module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center my-3"
  }, [_c('span', {
    staticClass: "darker font-weight-600 mr-2",
    on: {
      "click": _vm.testCalc
    }
  }, [_vm._v("\n        Seller:\n    ")]), _vm._v(" "), _c('seller-picker', {
    staticClass: "w-100",
    attrs: {
      "reservation": _vm.reservation,
      "orignalSeller": _vm.reservation.creatorAgent ? _vm.reservation.creatorAgent : _vm.account,
      "agentList": _vm.eventPossibleAgentsList(_vm.reservation.event)
    },
    on: {
      "allDownloaded": _vm.sellersLoaded,
      "input": _vm.sellerChanged
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-42d9890d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d9890d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/AgentSelector.vue
// module id = 1796
// module chunks = 0